jQuery('.search-icon, .close-icon').click(function(e){
    e.preventDefault();
    jQuery('.search-form-wrapper').toggleClass('open');
    jQuery('body').toggleClass('locked');
  });